import React, {useState, useEffect} from 'react';
import Rail from '@dazn/lp-web/src/components/Rail/Rail';
import {IStandardRail} from '@dazn/lp-web/src/types/rail.types';
import {standardRailProxy} from '@dazn/lp-web/src/proxies';
import fetchRails from '@dazn/lp-web/src/services/rail.service';

interface IStandardRailProps {
    data: IStandardRail;
    key: number;
    disableAnimation: boolean;
}

const StandardRail: React.FC<IStandardRailProps> = ({
    data: standardRail,
    disableAnimation
}) => {
    const [rail, setRail] = useState<IStandardRail | null>(standardRail);

    useEffect(() => {
        (async function () {
            try {
                const result = await fetchRails([
                    {
                        railId: standardRail.railId,
                        railParams: standardRail.railParams
                    }
                ]);
                setRail(standardRailProxy(standardRail, result?.[0]));
            } catch (err) {
                console.log(err);
            }
        })();
    }, []);

    if (!rail || !rail.tiles.length) {
        return null;
    }

    return (
        <Rail
            key={rail.railId}
            rail={rail}
            disableAnimation={disableAnimation}
        />
    );
};

export default StandardRail;
